import { render, staticRenderFns } from "./InvoicesStats.vue?vue&type=template&id=4b65f6dd"
import script from "./InvoicesStats.vue?vue&type=script&lang=ts"
export * from "./InvoicesStats.vue?vue&type=script&lang=ts"
import style0 from "./InvoicesStats.vue?vue&type=style&index=0&id=4b65f6dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports